import { render, staticRenderFns } from "./OkCancelModal.vue?vue&type=template&id=c4c98888&lang=pug"
import script from "./OkCancelModal.vue?vue&type=script&lang=ts"
export * from "./OkCancelModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports